import 'sticky-kit/dist/sticky-kit.js';

export default () => {
    $(".js-sticky").stick_in_parent({parent: 'body'});
};


// WEBPACK FOOTER //
// ./resources/js/modules/sticky-header.js